import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ProjectConfigurationsApiService from '@lib/api-services/ProjectConfigurationsApiService';

export default class SetProductSerialNumberModal extends React.Component {

    state = {
        productSerialNumber: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            productSerialNumber: props.productSerialNumber
        }
    }

    onSaveClick = () => {
        const api = APIServicesRegistry.getService(ProjectConfigurationsApiService);
        api.setProductSerialNumber({
            projectId: this.props.projectId,
            configurationId: this.props.configurationId,
            productSerialNumber: this.state.productSerialNumber
        }).then(() => {
            if (this.props.onSuccess) {
                this.props.onSuccess(this.state.productSerialNumber);
            }
        })
    }

    render() {
        return (
            <Modal overflow="inherit" isOpen={this.props.visible} onClose={this.props.onClose}>
                <Modal.Header>{__('Set product serial number')}</Modal.Header>
                <Modal.Body>
                    <div>
                        <label htmlFor="serial-number">{__('Product serial number')}:</label>
                        <input type="text" id="serial-number" value={this.state.productSerialNumber}
                               onChange={e => this.setState({productSerialNumber: e.target.value})}></input>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button theme={Button.Theme.BorderOnly} onClick={this.props.onClose}>{__('Cancel')}</Button>
                    <Button theme={Button.Theme.BorderOnly} onClick={this.onSaveClick}>{__('Save')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}